import * as React from "react";
import { ReactElement } from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import {
  TC_FULL_DESCRIPTION_PAUSE_SPEAK_TEXT,
  TC_FULL_DESCRIPTION_SPEAK_TEXT,
} from "../../../../utils/tc_svgs";
import { AppButton } from "../../../Generic/AppButton";
import { AppIcon } from "../../../Generic/AppIcon";

export interface ReadTextButtonProps {
  show: boolean;
  onClick: () => void;
  isPlaying: boolean;
}

const ReadTextButton = React.memo(function ReadTextButton(
  props: ReadTextButtonProps
): ReactElement {
  return (
    <>
      {props.show ? (
        <div className="DescriptionReadTextButtonContainer">
          <AppButton onClick={props.onClick} variant="filled" className="DescriptionReadTextButton">
            <AppIcon
              icon={
                props.isPlaying
                  ? TC_FULL_DESCRIPTION_PAUSE_SPEAK_TEXT
                  : TC_FULL_DESCRIPTION_SPEAK_TEXT
              }
              size={30}
            />
            <span>
              {props.isPlaying ? translate(STRINGS.PAUSE_READING) : translate(STRINGS.READ_TEXT)}
            </span>
          </AppButton>
        </div>
      ) : (
        <></>
      )}
    </>
  );
});

export default ReadTextButton;
